import React, { Component, Fragment } from "react"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import _ from "lodash"
import shop from "shop/shop"
import moment from "moment"
import { Col } from "elemental-react16"
import Price from "components/Price/Price"
import { fetchExtraOrderRessources } from "theme/arnoldsports/pages/AccountPage";
import AccountReset from "components/Account/AccountReset"
import { Button, Label, Modal, Pagination, Table, Icon, Loader, Image, Input, Message, Responsive } from "semantic-ui-react";
import MediaQuery from "react-responsive"
import ProductTable from "components/Product/ProductTable"
import FooterCheckout from "./checkout/FooterCheckout"
//import OrderModel from "../shop/OrderModel";
import Collapsible                                                                    from 'react-collapsible';
import CartTotal from "components/Cart/CartTotal"
import languageStore               from "stores/languageStore"

class AccountOrderDetailPage extends Component {
  state = {
    order  : false,
    orderId: false,
    openRechnung: false,
    openLieferschein: false,
    openAuftrag: false,
    open: false,
    openTab: "order",
  }
  
  
  constructor( props ) {
    super()
    console.log( `new order page`, props, { orderId: props.match.params.orderId } )
    if ( props && props.match.params && props.match.params.orderId ) {
      this.loadOrder( props.match.params.orderId )
      this.setState( { orderId: props.match.params.orderId } )
    }
  }
  
  async loadOrder( orderId ) {
    const order = await this.getSelectedOrder( orderId )
    
    this.setState( { order } )
    this.setState( { openTab: order.extras && order.extras.rahmenauftrag && order.extras.rahmenauftrag == "1" ? "frameworkAgreement" : "order" } )
  }

  handleTabButtons = (name ) => {
      this.setState({ openTab: name });
	}
  
  render() {
    const { order, openTab } = this.state
    const { backOrderMode } = this.props.match.params
    const { currentLanguage } = languageStore
    const {open, openRechnung, openAuftrag, openLieferschein} = this.state
    var counterLieferschein = 0
    var counterRechnung = 0
    var counterAuftrag = 0
    if ( !order ) return (
      <div>
        <Loader active/>
      </div>
    )
    let hasDeliveryAddress = true
    let deliveraddress = order.bill 
    let billingAddress = order.customer 
    if(deliveraddress.street == billingAddress.street && 
       deliveraddress.zip == billingAddress.zip && 
       deliveraddress.city == billingAddress.city &&
       deliveraddress.country == billingAddress.country) {
      hasDeliveryAddress = false
    }
    console.log( { order } )
    console.log("this.props", this.props, languageStore)
    return (<Fragment>
              <div className="accountPageHeader">
                <div  className="container pt4 ">
                  {/*<p className="fw6 f4 black-50">{translate( "My Account" )}</p> */}
            <MediaQuery minWidth={768}>
                          <Table className="accountTablePW" >
              <tbody>
              <tr>
                <td className="tl">
                  <p className="fw7 f2">{shop.session.value.title}</p>
                </td>
                <td className="tr">
                  {/*<div className="tr"><AccountReset email={shop.session.value.email}/></div> */}
                </td>
              </tr>
              <tr>
                <td className="tl">
                  <p className="fw7 f3">{translate( "Kundennummer" )}: {shop.session.value.map_id}</p>
                </td>
                <td className="tr">
                  <div className="tr"><AccountReset email={shop.session.value.email}/></div>
                </td>
              </tr>
              </tbody>
            </Table>
              </MediaQuery>
              <MediaQuery maxWidth={767}>
                <div className="flex flex-column items-start">
                  <div className="pb2"><p className="fw7 f3">{shop.session.value.title}</p></div>
                  <div className="pb3 pt2">
                    <p className="fw7 f4">{translate( "Kundennummer" )}: {shop.session.value.map_id}</p>
                  </div>
                  <div className="pb4 pt2"><AccountReset email={shop.session.value.email}/> </div>
                </div>
                </MediaQuery>
                  <div className="flex flex-row justify-start w-100" style={{
                          overflowX: "auto",
                          WebkitOverflowScrolling: "touch",
                          whiteSpace: "nowrap",
                          msOverflowStyle: "none",
                          scrollbarWidth: "none",
                          }}  >
                    <div className="pl2 pb2" style={{borderBottom: `${openTab == "dashboard" ? "2px solid #369678" : "2px solid rgb(201, 201, 201)"}`}}>
                                      <Link className="black"
                     to={`/account/?referer=orders/${order.map_id}_dashboard`}
                     state={{ prevPath: this.props.location.pathname }}>
                      <button  className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "dashboard" ? "none" : "none"}`, 
                      backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("dashboard")}><span className="pa2 fw7 f4">{translate("Dashboard")}</span></button></Link></div>
                      <div className=" pb2" style={{borderBottom: `${openTab == "address" ? "2px solid #369678" : "2px solid rgb(201, 201, 201)"}`}}>
                                                          <Link className="black"
                     to={`/account/?referer=orders/${order.map_id}_address`}
                     state={{ prevPath: this.props.location.pathname }}>
                      <button className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "address" ? "none" : "none"}`, 
                      backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("address")}><span className="pa2 fw7 f4">{translate("Adressen")}</span></button></Link></div>
                      <div className=" pb2" style={{borderBottom: `${openTab == "order" ? "2px solid #369678" : "2px solid rgb(201, 201, 201)"}`}}>
                                                          <Link className="black"
                     to={`/account/?referer=orders/${order.map_id}_order`}
                     state={{ prevPath: this.props.location.pathname }}>
                      <button className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "frameworkAgreement" ? "none" : "none"}`, 
                      backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("frameworkAgreement")}><span className="pa2 fw7 f4">{translate("Bestellungen")}</span></button></Link></div>

                    <div className=" pb2" style={{borderBottom: `${openTab == "frameworkAgreement" ? "2px solid #369678" : "2px solid rgb(201, 201, 201)"}`}}>
                                                          <Link className="black"
                     to={`/account/?referer=orders/${order.map_id}_frameworkAgreement`}
                     state={{ prevPath: this.props.location.pathname }}>
                      <button className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "frameworkAgreement" ? "none" : "none"}`, 
                      backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("frameworkAgreement")}><span className="pa2 fw7 f4">{translate("Rahmenaufträge")}</span></button></Link></div>

                     <div className=" pb2" style={{borderBottom: `${openTab == "contact" ? "2px solid #369678" : "2px solid rgb(201, 201, 201)"}`}}>
                                                          <Link className="black"
                     to={`/account/?referer=orders/${order.map_id}_contact`}
                     state={{ prevPath: this.props.location.pathname }}>
                      <button className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "contact" ? "none" : "none"}`, 
                      backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("contact")}><span className="pa2 fw7 f4">{translate("Ansprechpartner")}</span></button></Link></div>
                                    <div className=" pb2" style={{borderBottom: `${openTab == "newsletter" ? "2px solid #369678" : "2px solid rgb(201, 201, 201)"}`}}>
							<button className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "newsletter" ? "none" : "none"}`, 
								backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("newsletter")}><span className="pa2 fw7 f4">{translate("Newsletter")}</span></button></div>
                      <div className="w-100" style={{borderBottom: "2px solid rgb(201, 201, 201)"}}></div>
                  </div>
      
                </div>
              </div>
              <div className="accountPageBody">
              <div className="container pt5 pb5">
                      <div className="fr">
                                              <div className="flex flex-column justify-end" >
                                          <Link className="product-inner fr"
                     to={`/account/?referer=orders/${order.map_id}_${order.extras && order.extras.rahmenauftrag && order.extras.rahmenauftrag == "1" ? "frameworkAgreement" : "order"}`}
                     state={{ prevPath: this.props.location.pathname }}><Button style={{borderRadius: "35px", height: "40px", width: "220px"}} primary><p className="fw6">{translate( "Zurück zur Übersicht" )}</p></Button></Link>
                                       {order.extras && order.extras.tracking && <a className="product-inner fr pt3"
                     href={`//tracking.dpd.de/status/${currentLanguage == "de" ? "de_DE" : "en_US"}/parcel/${order.extras.tracking}`}
                     ><Button style={{borderRadius: "35px", height: "40px", width: "220px", backgroundColor: "#a50c53"}} primary><p className="fw6">{translate( "Sendungsverfolgung" )}</p></Button></a>}
                      </div>
                      </div>
        <h1 className="fw7 pb3">
          {backOrderMode && <div>{translate( "Rückstände" )} #{order.map_id}</div>}
          {!backOrderMode && <div>{translate( "Bestellung" )} #{order.map_id}</div>}
        </h1>
        
        <div>
          <p className="f4 fw5">{translate("Bestellt am")}: {moment(order.created).locale('de').format('DD.MM.YYYY')} </p>
          {order.extras && order.extras.rahmenauftrag && order.extras.rahmenauftrag == "1" ? <p  className="f4 fw5">{translate("Abrufbar bis")}: {moment( order.deliverdate ).format( "DD.MM.YYYY" )} </p>
           : <p  className="f4 fw5">{translate("Status")}: {backOrderMode ? translate("Rückstand") : translate("Geliefert")} </p>}
        </div>

        {order.extrainfo && order.extrainfo.length > 0 && <React.Fragment>
          

        <MediaQuery maxWidth={767}>
          <Collapsible tabIndex={0} open={true} trigger={translate( "Dokumente" )}>
          <table>
            <tbody>
          {console.log("order.extrainfo", order.extrainfo)}
          
            {_.sortBy( order.extrainfo, "type" ).map( ( pdf, index ) => {
              return <tr key={pdf.map_id}>
                <td className="w-100">
                  <div className="flex flex-row items-center pa3 w-100">
                <a href={pdf.url} download={`${pdf.map_id}.pdf`} key={pdf.map_id} className="pa4 bg-white mr3 w-100 mw5 box-shadow relative">
                <div className="pt2">
                  {/*<div className="f7">{pdf.content}</div> */}
                  <div className="f5 text-bold ttu">{translate( `${pdf.type === "2" ? translate("Rechnung")  :
                                                                    pdf.type === "4" ? translate("Lieferschein") : 
                                                                    pdf.type === "1" ? translate("Auftragsbestätigung") : translate("Rechnung") 
                   }` )}</div>
                </div>
                <div className="pointer-events-none absolute black-10 right-1 top-1 f3 m-auto flex flex-col items-center justify-center text-bold">
                  <div>PDF</div>
                </div>
              </a>
              </div>
              </td>
              </tr>
            } )}
          </tbody>
          </table>
          </Collapsible>
          </MediaQuery>
          <MediaQuery minWidth={768}>
            <h3 className="mt4">{translate( "Dokumente" )}</h3>
                      <Table >
        <colgroup>
          <col width="50%"/>
        </colgroup>
        
        <Table.Header>
          <tr>
            <th className="tc">{translate( "Rechnung" )}</th>
          </tr>
        </Table.Header>
        <Table.Body>
          {console.log("order.extrainfo", order.extrainfo)}
          <div className="flex flex-row items-center pa3">
            {_.sortBy( order.extrainfo, "type" ).map( ( pdf, index ) => {
              return <a href={pdf.url} download={`${pdf.map_id}.pdf`} key={pdf.map_id} className="pa4 bg-white mr3 w-100 mw5 box-shadow relative">
                <div className="pt4">
                  {/*<div className="f7">{pdf.content}</div> */}
                  <div className="f5 text-bold ttu">{translate( `${pdf.type === "2" ? translate("Rechnung")  :
                                                                    pdf.type === "4" ? translate("Lieferschein") : 
                                                                    pdf.type === "1" ? translate("Auftragsbestätigung") : translate("Rechnung") 
                   }` )}</div>
                </div>
                <div className="pointer-events-none absolute black-10 right-1 top-1 f1 m-auto flex flex-col items-center justify-center text-bold">
                  <div>PDF</div>
                </div>
              </a>
            } )}
          </div>
          </Table.Body>
                    </Table>
            </MediaQuery>

        </React.Fragment>}

          <MediaQuery minWidth={768} >            <Table className="orderDetailTable">
              <colgroup>
                <col width="25%"/>
                <col width="25%"/>
                <col width="25%"/>
                <col width="25%"/>
                </colgroup>
                <tbody>
                  <tr>
                    <td><span className="black-50">{translate( "Ihre Daten" )} </span>
                    <div className="pt3 f5">
                      <p>
                        {translate( "Kundennummer" )}: <span className="b">{order.customer.map_id}</span><br/>
                        {translate( "E-Mail" )}: <span className="b">{order.customer.email}</span><br/>
                        {translate( "Telefon" )}: <span className="b">{order.customer.phone}</span>
                        </p></div></td>
                    <td><span className="black-50">{translate( "Rechnungsadresse" )} </span>
            <div className="pt3">
              <strong> {billingAddress.title}</strong> <br />
              {billingAddress.street} <br />
              {billingAddress.pcode} {billingAddress.city}<br />
              {/*{billingAddress.country}<br /> */}
            </div></td>
                    <td><span className="black-50">{translate( "Lieferadresse" )} </span>
            <div className="pt3">
              {!hasDeliveryAddress && <div className={"b"}>{translate( "Lieferadresse entspricht der Rechnungsadresse" )}</div>}
              {deliveraddress && <div className="mb4">
                <strong>{deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br />
                {deliveraddress.street}<br />
                {deliveraddress.pcode} {deliveraddress.city}<br />
                {/*{deliveraddress.country}<br /> */}
              </div>
              }
            </div></td>
                    
                    <td><span className="black-50">{translate( "payment" )}</span>
            <div className="pt3">
              <strong>{translate( "Nach Vereinbarung" )}</strong>
            </div></td>
                  </tr>
                </tbody>
            </Table>
            </MediaQuery>
            <MediaQuery maxWidth={767}>
          <table className="orderDetailTable">
              <colgroup>
                <col width="50%"/>
                <col width="50%"/>
                </colgroup>
                <tbody>
                  <tr>
                    <td><span className="black-50">{translate( "Ihre Daten" )} </span>
                    <div className="pt3 f5">
                      <p>
                        {translate( "Kundennummer" )}: <span className="b">{order.customer.map_id}</span><br/>
                        {translate( "E-Mail" )}: <span className="b">{order.customer.email}</span><br/>
                        {translate( "Telefon" )}: <span className="b">{order.customer.phone}</span>
                        </p></div></td>
                                            <td><span className="black-50">{translate( "payment" )}</span>
            <div className="pt3">
              <strong>{translate( "Nach Vereinbarung" )}</strong>
            </div></td>

            </tr>
            <tr>
            <td><span className="black-50">{translate( "Rechnungsadresse" )} </span>
            <div className="pt3">
              <strong> {billingAddress.title}</strong> <br />
              {billingAddress.street} <br />
              {billingAddress.pcode} {billingAddress.city}<br />
              {/*{billingAddress.country}<br /> */}
            </div></td>
                    <td><span className="black-50">{translate( "Lieferadresse" )} </span>
            <div className="pt3">
              {!hasDeliveryAddress && <div className={"b"}>{translate( "Lieferadresse entspricht der Rechnungsadresse" )}</div>}
              {deliveraddress && <div className="mb4">
                <strong>{deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br />
                {deliveraddress.street}<br />
                {deliveraddress.pcode} {deliveraddress.city}<br />
                {/*{deliveraddress.country}<br /> */}
              </div>
              }
            </div></td>
                    

                  </tr>
                </tbody>
            </table>
              </MediaQuery>
        <ProductTable rahmenauftrag={order.extras && order.extras.rahmenauftrag && order.extras.rahmenauftrag == "1" ? true : false} success={true} readOnly={true} cart={shop.cart} accountPage={true} products={order.positions} />
            <div className="cf pb2 pt2">
              <Message negative className="">
                <div className="total ">
                  <div className="ph3">
                    <Icon name="info" />{translate( "CartDeliverCostHint" )}
                  </div>
                </div>
                
              </Message>
						</div>
              <MediaQuery minWidth={768}>
                                    <Table className="orderDetailTable">
                        <colgroup>
                          <col width="10%"/>
                          <col width="20%"/>
                          <col width="70%"/>
                        </colgroup>
                        <tbody>
                          <tr>
                            <td rowSpan={3} >
                              <div className="pt3 pl2 pr2">
                            <Link className={"logo"} to="/home/">
                          <img
                            src={shop.config.logo}
                            alt="" />
                        </Link></div>
                            </td>
                            <td rowSpan={3} colSpan="3" className="pt4 pa2">
                            <p className="f4 fw7 pt3 pr3 pl3">{translate("Sie haben Fragen zu Ihrer Bestellung?")}</p>
                            <div className="flex flex-row justify-start"><a className="pl3 pr2 pb2" href={`tel:+4959197778649`}><span className="f5 fw5" style={{ color: "#369678", backgroundColor: "transparent" }}><Icon
                                        name={"phone"} />+49 (0) 591 - 97 77 86 49</span></a>
                              <a className="pl2 pr2 pb2" href={`mailto:vertrieb@trend-soft.de?subject=Anfrage bezüglich des Bestellvorgangs, Kunde #${shop.session.value.map_id}`}>
                                <span className="f5 fw5" style={{ color: "#369678", backgroundColor: "transparent" }}><Icon
                              name={"mail"} />vertrieb@trend-soft.de</span></a>
                              </div>
                            </td>
                            <td rowSpan={3} className="fr">
                              <Table className="orderBackOrderTable">
                                <tbody>  
                                  <tr className="bb pt2 pb2">                                    
                                      <td className="f4 pa3 bb" style={{minWidth: "285px", maxWidth: "285px", width: "285px"}}><strong>{translate( "Positionen:" )}</strong></td>
                                      <td className=" bb tr pr2"><p className="tr pr2">{order.positions.length}</p></td>
                                    </tr>
                                    <tr className="bb pt2 pb2">
                                      <td className="f4 pa3" style={{minWidth: "150px", maxWidth: "150px", width: "150px"}}><strong>{translate( "Zwischensumme (netto):" )}</strong></td>
                                      <td style={{minWidth: "90px", maxWidth: "90px", width: "90px"}} className="tr pr2"><p className="fr pr2"><Price>{order.netto}</Price></p></td>
                                    </tr>
                                    <tr className="bb pt2 pb2">
                                      <td className="f4 pa3" style={{minWidth: "150px", maxWidth: "150px", width: "150px"}}><strong>{translate( "zzgl. 19 % MwSt.:" )}</strong></td>
                                      <td style={{minWidth: "90px", maxWidth: "90px", width: "90px"}} className="tr pr2"><p className="fr pr2"><Price>{Number(order.netto*0.19)}</Price></p></td>
                                    </tr>
                                    <tr className="bb pt2 pb2">
                                      <td className="f4 pa3" style={{minWidth: "150px", maxWidth: "150px", width: "150px"}}><strong>{translate( "Gesamtsumme (brutto):" )}</strong></td>
                                      <td style={{minWidth: "90px", maxWidth: "90px", width: "90px"}} className="tr pr2"><p className="fr pr2"><Price>{Number(order.netto*1.19)}</Price></p></td>
                                    </tr>
                                    <tr className="bb pt7 pb2">
                                      <td className="f4 pa3 pt7" style={{minWidth: "150px", maxWidth: "150px", width: "150px"}}><strong>{translate( "Offen:" )}</strong></td>
                                      <td style={{minWidth: "90px", maxWidth: "90px", width: "90px"}} className="tr pr2"><p className="fr pr2"><Price>{order.nettoBackorder}</Price></p></td>
                                    </tr>
                                  </tbody>
                              </Table></td>
                            </tr>
  
                        </tbody>
                    </Table>
                </MediaQuery>
                <MediaQuery maxWidth={767}>
                  <div className=" pt4 pb3">                  
                    <table className="w-100">
                    <colgroup>
                        <col width="70%"/>
                        <col width="30%"/>
                      </colgroup>
                      <tbody>
                                  <tr className="bb pt2 pb2">                                    
                                      <td className="f4 pa3 bb" style={{minWidth: "285px", maxWidth: "285px", width: "285px"}}><strong>{translate( "Positionen:" )}</strong></td>
                                      <td className=" bb tr pr2"><p className="tr pr2">{order.positions.length}</p></td>
                                    </tr>
                                    <tr className="bb pt2 pb2">
                                      <td className="f4 pa3" style={{minWidth: "150px", maxWidth: "150px", width: "150px"}}><strong>{translate( "Zwischensumme (netto):" )}</strong></td>
                                      <td style={{minWidth: "90px", maxWidth: "90px", width: "90px"}} className="tr pr2"><p className="fr pr2"><Price>{order.netto}</Price></p></td>
                                    </tr>
                                    <tr className="bb pt2 pb2">
                                      <td className="f4 pa3" style={{minWidth: "150px", maxWidth: "150px", width: "150px"}}><strong>{translate( "zzgl. 19 % MwSt.:" )}</strong></td>
                                      <td style={{minWidth: "90px", maxWidth: "90px", width: "90px"}} className="tr pr2"><p className="fr pr2"><Price>{Number(order.netto*0.19)}</Price></p></td>
                                    </tr>
                                    <tr className="bb pt2 pb2">
                                      <td className="f4 pa3" style={{minWidth: "150px", maxWidth: "150px", width: "150px"}}><strong>{translate( "Gesamtsumme (brutto):" )}</strong></td>
                                      <td style={{minWidth: "90px", maxWidth: "90px", width: "90px"}} className="tr pr2"><p className="fr pr2"><Price>{Number(order.netto*1.19)}</Price></p></td>
                                    </tr>
                                    <tr className="bb pb2">
                                      <td className="f4 pa3" style={{minWidth: "150px", maxWidth: "150px", width: "150px"}}><strong>{translate( "Offen:" )}</strong></td>
                                      <td style={{minWidth: "90px", maxWidth: "90px", width: "90px"}} className="tr pr2"><p className="fr pr2"><Price>{order.nettoBackorder}</Price></p></td>
                                    </tr>
                      </tbody>
                  </table>
                  </div>
                  <div>
                    <table className="w-100">
                    <colgroup>
                        <col width="30%"/>
                        <col width="70%"/>
                      </colgroup>
                      <tbody>
                        <tr className=" pt2 pb2">                                    
                            <td rowSpan={3} >
                              <div className="pt3 pl2 pr2">
                            <Link className={"logo"} to="/home/">
                          <img
                            src={shop.config.logo}
                            alt="" />
                        </Link></div>
                            </td>
                            <td rowSpan={3} colSpan="2" className="pt4 pa2">
                            <p className="f4 fw7 pt3 pr3 pl3">{translate("Sie haben Fragen zu Ihrer Bestellung?")}</p>
                            <div className="flex flex-row justify-start"><a className="pl3 pr2 pb2" href={`tel:+4959197778649`}><span className="f6 fw5" style={{ color: "#369678", backgroundColor: "transparent" }}><Icon
                                        name={"phone"} />+49 (0) 591 - 97 77 86 49</span></a>
                              <a className="pl2 pr2 pb2" href={`mailto:vertrieb@trend-soft.de?subject=Anfrage bezüglich des Bestellvorgangs, Kunde #${shop.session.value.map_id}`}>
                                <span className="f6 fw5" style={{ color: "#369678", backgroundColor: "transparent" }}><Icon
                              name={"mail"} />vertrieb@trend-soft.de</span></a>
                              </div>
                            </td>
                          </tr>
                      </tbody>
                  </table>
                  </div>

                  </MediaQuery>
              {/*
                       <h3 className="mt4">{translate( "cart.positions" )}</h3>
        <div className="pb3">
          <OrderDetailTable order={order} filterBackorders={!!backOrderMode} products={order.positions} netto={order.netto}/>
        </div>
        <p>
          <span className="ttu b">{translate( "shop.comment" )}: </span>
          {order.comment ? order.comment : "-"}
        </p>
        
        <p>
          <span className="ttu b">{translate( "Erstellt am" )}: </span>
          {moment( order.created )
            .format( "DD.MM.YYYY" )}
        </p>
               */}
      
      </div>
              </div>

    </Fragment>
      

    )
  }
  
  getSelectedOrder( orderId ) {
    return shop.fetch( "/shop/rest/data/orders?start=0&count=120&open=0" )
      .then( res => res.values )
      .then( orders => {
        let order = orders.filter( o => o.map_id == orderId )
        return _.first( order )
      } )
      .then( order => fetchExtraOrderRessources( order ) )
  }
}

const OrderDetailTable = ( { products, netto, order, filterBackorders } ) => {
  const filteredProducts = filterBackorders ? products.filter( p => p.open !== 0 ) : products
  console.log("ORDERDETAILTABLE:", products)
  console.log("nettobackorder: ",order)
  return (
    <div className="table-scroller">
      <MediaQuery maxWidth={767}>
      <table className="mobileRespTable" >
          <colgroup>
            <col width="10%"/>
            <col width="90%"/>
            </colgroup>
          <tbody>
          {filteredProducts && filteredProducts.map( ( product, index ) => <OrderDetailRow key={index + "_" + product.map_id} product={product}/> )}
          <tr>
            <td className="tr" colSpan="1">
              <span className="">{translate( "Zwischensumme" )}</span>
            </td>
            <td className="tr" colSpan="5">
              <span className="tr ttu f3 pv3 db b"><Price>{netto}</Price></span>
            </td>
          </tr>
          {order.nettoBackorder != 0 && <tr>
            <td className="tr" colSpan="1">
              <span className="">{translate( "offen" )}</span>
            </td>
            <td className="tr" colSpan="5">
              <span className="tr ttu f3 pv3 db b"><Price>{order.nettoBackorder}</Price></span>
            </td>
          </tr>}
        </tbody>
      </table>
      </MediaQuery>
      <MediaQuery minWidth={768}>
              <Table>
                <colgroup>
                  <col width="10%"/>
                  <col width="10%"/>
                  <col width="40%"/>
                  <col width="20%"/>
                  <col width="10%"/>
                  <col width="10%"/>
                </colgroup>
                
                <Table.Header>
                  <tr>
                    <th>{translate( "product.articlenr" )}</th>
                    <th>{translate( "" )}</th>
                    <th>{translate( "product.label" )}</th>
                    <th className="tl">{translate( "product.amount" )}</th>
                    <th className="tl">{translate( "shop.VE" )}</th>
                    <th className="tr">{translate( "Gesamtpreis" )}</th>
                    <th className="tr">{translate( "" )}</th>
                    <th className="tr"></th>
                  </tr>
                </Table.Header>
                
                <Table.Body>
                  {filteredProducts && filteredProducts.map( ( product, index ) => <OrderDetailRow key={index + "_" + product.map_id} product={product}/> )}
                  <tr>
                    <td className="tr" colSpan="1">
                      <span className="">{translate( "Zwischensumme" )}</span>
                    </td>
                    <td className="tr" colSpan="5">
                      <span className="tr ttu f3 pv3 db b"><Price>{netto}</Price></span>
                    </td>
                  </tr>
                  {order.nettoBackorder != 0 && <tr>
                    <td className="tr" colSpan="1">
                      <span className="">{translate( "offen" )}</span>
                    </td>
                    <td className="tr" colSpan="5">
                      <span className="tr ttu f3 pv3 db b"><Price>{order.nettoBackorder}</Price></span>
                    </td>
                  </tr>}
                </Table.Body>
              </Table>
      </MediaQuery>
    </div>
  )
}

OrderDetailTable.propTypes = {
  products: PropTypes.array,
}


const OrderExtraDetailTable = ( { order } ) => {
  var counterLieferschein = 0
  var counterRechnung = 0
  var counterAuftrag = 0
  return (
    
    {/*<div className="table-scroller">
      <Table>
        <colgroup>
          <col width="33%"/>
          <col width="33%"/>
          <col width="33%"/>
        </colgroup>
        
        <Table.Header>
          <tr>
            <th className="tc">{translate( "Rechnung" )}</th>
            <th className="tc">{translate( "Lieferschein" )}</th>
            <th className="tc">{translate( "Auftrag" )}</th>
          </tr>
        </Table.Header>
        
        <Table.Body>
        <tr>
        <td className="tc">        {order.extrainfo.map((answer, r) => {     
           if(answer.content && answer.content.includes("VKSF")){
            counterRechnung = counterRechnung +1
            return (<div key={answer} answer={answer}><Button 
              size={"tiny"} basic onClick={() => { 
       }}>{counterRechnung + translate( ". Rechnung" )}</Button><br/><br/></div>)
           }
        })}</td>
          <td className="tc">        {order.extrainfo.map((answer, i) => {     
           
           if(answer.content && answer.content.includes("VKLS")){
            
            counterLieferschein = counterLieferschein+1
            return (<div colSpan="1" key={answer} answer={answer}><Button 
              size={"tiny"} basic onClick={() => {
       }}>{counterLieferschein + translate( ". Lieferschein" )}</Button><br/><br/></div>)
           }
        })}</td>
        <td className="tc">        {order.extrainfo.map((answer, a) => {     
             
           if(answer.content && answer.content.includes("VKLS")){
            counterAuftrag++
            return (<div colSpan="1" key={answer} answer={answer}><Button 
              size={"tiny"} basic onClick={() => {
       }}>{counterAuftrag + translate( ". Auftrag" )}</Button><br/><br/></div>)
           }
        })}</td>
          </tr>
        </Table.Body>
      </Table>
      </div>*/}
  )
}

OrderExtraDetailTable.propTypes = {
  products: PropTypes.array,
}

const OrderDetailRow = ( { product } ) => {
  let baseUrl = (process.env.BSHOP_BASE_URL || process.env.REACT_APP_API)
  return (
    <React.Fragment>
      <MediaQuery maxWidth={767}>
                  <tr className={` ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
            <td className="tl pt2 pb2">
            <Link to={`/product/${product.article_id}`}><Image style={{maxWidth: "70px",maxHeight: "70px", minWidth: "70px",minHeight: "70px", overflow: "hidden",objectFit: "contain"}}
                         src={`${baseUrl}/shop/rest/data/images/description/${product.article_id}/1?size=small`} ></Image></Link></td>
                        <td className="pr2 bb b--black-20 tr f5 fw7"><Link to={`/product/${product.map_id}`}>
                          <strong>{product.map_id}</strong> <br/>
                          <strong>{product.desc.short_des}</strong>
                        </Link>
                </td>
                <td></td>
              </tr>
              <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
                <td className="pl2  fw7 f5">{translate( "Artikelnummer:" )} </td>
                <td  className="pr2 bb b--black-20 tr f5 fw7"><a href={`/product/${product.article_id}`} key={product.article_id} className="block bg-white text-gray-900 border rounded-lg border-gray-100 shadow-sm hover:shadow-lg transition-all p-4 mb-4">{product.article_id}</a></td>
              </tr>
              <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
                <td className="pl2  fw7 f5">{translate( "Bezeichnung:" )} </td>
                <td  className="pr2 bb b--black-20 tr f5 fw7">{product.desc}</td>
              </tr>
              <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
                <td className="pl2  fw7 f5">{translate( "Stück:" )} </td>
                <td  className="pr2 bb b--black-20 tr f5 fw7">{product.count}</td>
              </tr>
              {/*<tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
                <td className="pl2  fw7 f5">{translate( "VE:" )} </td>
                <td  className="pr2 bb b--black-20 tr f5 fw7">{Math.round( product.unit_multi )} {translate( "Stück" )}</td>
              </tr> */}
              <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
                <td className="pl2  fw7 f5">{translate( "Gesampreis:" )} </td>
                <td  className="pr2 bb b--black-20 tr f5 fw7">
                <div><Price>{product.sum}</Price></div>
                {product.open > 0 && <div><span className="black-70 f7">{translate( "offen" )}</span> <Price>{product.open * product.price}</Price></div>}</td>
              </tr>
              <tr className={` ProductRowDefReturnMobileRight step ${(product.count-1) > 0 && "inCart"}`}>
                <td className="pl2  fw7 f5">{translate( "" )} </td>
                <td className="tr"><Button icon={"shopping cart"} onClick={async () => {
          const p = await shop.product( product.article_id )
          if ( p ) {
            p.count = 1
            shop.cart.add( p )
            shop.toast( translate( "Produkt hinzugefügt" ), "success", false, "bottom" )
          } else {
            shop.toast( translate( "Produkt nicht mehr verfügbar" ), "info", false, "bottom" )
          }
        }}/></td>
              </tr>
        </MediaQuery>
      <MediaQuery minWidth={768}>
            

      <tr className={`${product.open !== 0 && "isOpenPosition"}`}>
      <td className="pt2 pb2 "><Link to={`/product/${product.article_id}`}><Image style={{maxWidth: "70px",maxHeight: "70px", minWidth: "70px",minHeight: "70px", overflow: "hidden",objectFit: "contain"}}
                 src={`${baseUrl}/shop/rest/data/images/description/${product.article_id}/1?size=small`} ></Image></Link> 
                 </td>
      <td><a href={`/product/${product.article_id}`} key={product.article_nr} className="block bg-white text-gray-900 border rounded-lg border-gray-100 shadow-sm hover:shadow-lg transition-all p-4 mb-4">{product.article_nr}</a></td>
        <td>
          <div>{product.desc}</div>
          <div className={""}>
            {product.open !== 0 && <div className={"blue"}>{translate( "Rückstand" )} <span className={"b blue"}>{product.open} </span></div>}
          </div>
        </td>
        <td className="tc">{product.count}</td>
        {/*<td className="tl" title={product.unit_multi}>{Math.round( product.unit_multi )} {translate( "Stück" )}</td> */}
        <td className="tl">
          <div><Price>{product.sum}</Price></div>
          {product.open > 0 && <div><span className="black-70 f7">{translate( "offen" )}</span> <Price>{product.open * product.price}</Price></div>}
        </td>
        <td className="tr"><Button icon={"shopping cart"} onClick={async () => {
          const p = await shop.product( product.article_id )
          if ( p ) {
            p.count = 1
            shop.cart.add( p )
            shop.toast( translate( "Produkt hinzugefügt" ), "success", false, "bottom" )
          } else {
            shop.toast( translate( "Produkt nicht mehr verfügbar" ), "info", false, "bottom" )
          }
        }}/></td>
      </tr>
        </MediaQuery>

    </React.Fragment>
  )
}

OrderDetailTable.propTypes = {
  product: PropTypes.object,
}

export default (AccountOrderDetailPage)



// WEBPACK FOOTER //
// ./src/theme/demo2025/pages/AccountOrderDetailPage.js